// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".qu{height:100%;display:flex;width:100%}.ru{width:100%}.su{height:700px}.tu{width:97%;margin-left:0}", "",{"version":3,"sources":["webpack://./src/components/uploadJobControl/UploadJobControl.module.scss"],"names":[],"mappings":"AAAA,IACC,WAAA,CACA,YAAA,CACA,UAAA,CAGD,IACC,UAAA,CAGD,IACC,YAAA,CAGD,IACC,SAAA,CACA,aAAA","sourcesContent":[".taskContainer {\r\n\theight: 100%;\r\n\tdisplay: flex;\r\n\twidth: 100%;\r\n}\r\n\r\n.scrollbar {\r\n\twidth: 100%;\r\n}\r\n\r\n.logContainer {\r\n\theight: 700px;\r\n}\r\n\r\n.divider {\r\n\twidth: 97%;\r\n\tmargin-left: 0;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"taskContainer": "qu",
	"scrollbar": "ru",
	"logContainer": "su",
	"divider": "tu"
};
export default ___CSS_LOADER_EXPORT___;
